import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTheme, ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';

import Sidenav from '../components/sidenav/sidenav.component';
import NotificationSidenav from '../components/notification-sidenav/notification-sidenav.component';
import ContentToolbar from '../components/content-toolbar/content-toolbar.component';
import MenuSidenav from '../components/menu-sidenav/menu-sidenav.component';

// Actions
import { toggleSidenav, setSidenavOpen, toggleSidenavVariant } from '../../actions/layout.actions';

import scss from './layout-classic.module.scss';
import styles from './layout-classic.style';

const ClassicLayout = ({ children, toggleSidenavVariant, setSidenavOpen }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumUp = useMediaQuery(theme.breakpoints.up('md'));

    useEffect(() => {
        const variant = isSmallScreen ? 'temporary' : 'persistent';
        toggleSidenavVariant(variant);
        setSidenavOpen(variant === 'persistent');
    }, [isSmallScreen, toggleSidenavVariant, setSidenavOpen]);

    useEffect(() => {
        if (isSmallScreen && isMediumUp) {
            toggleSidenavVariant('persistent');
            setSidenavOpen(true);
        } else if (isSmallScreen && !isMediumUp) {
            toggleSidenavVariant('temporary');
            setSidenavOpen(false);
        }
    }, [isSmallScreen, isMediumUp, toggleSidenavVariant, setSidenavOpen]);

    return (
        <ThemeProvider theme={theme}>
            <div className={scss['layout-classic-wrapper']}>
                <Sidenav>
                    <MenuSidenav />
                </Sidenav>
                <main className={scss['layout-classic-main']}>
                    <AppBar color="default" position="static">
                        <ContentToolbar />
                    </AppBar>
                    <div className={scss['layout-classic-content-wrapper']}>
                        <div className={scss['layout-classic-content']}>{children}</div>
                    </div>
                </main>
                <NotificationSidenav />
            </div>
        </ThemeProvider>
    );
};

function mapStateToProps(state) {
    return {
        layout: {
            sidenavOpen: state.layout.sidenavOpen,
        },
    };
}

ClassicLayout.propTypes = {
    children: PropTypes.node.isRequired,
    toggleSidenavVariant: PropTypes.func.isRequired,
    setSidenavOpen: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
    toggleSidenav,
    toggleSidenavVariant,
    setSidenavOpen,
})(ClassicLayout);
